<p-card class="non-member-display-card" data-cy="non-member-display-card">
  <ng-template pTemplate="header">
    <div id="non-member-display-card-header">
      <div id="non-member-display-card-header-title">
        <h1>
          {{ nonMember() !== null ? nonMember().NameFirst : 'VALUED' }}
          {{ nonMember() !== null ? nonMember().NameLast : 'CUSTOMER' }}
        </h1>
      </div>
    </div>
  </ng-template>
  <div class="non-member-display">
    <div class="non-member-display-column non-member-display-column-0">
      <app-non-member-information [nonMember]="nonMember()" class="full-height-width" />
    </div>
    <div class="non-member-display-column non-member-display-column-1">
      <app-non-member-recent-transactions-list
        [nonMember]="nonMember()"
        [orderPaymentsCount]="nonMember().OrderPayments?.length ?? 0"
        class="full-height-width"
      />
    </div>
  </div>
</p-card>
